import { store } from "../redux/store"

export const config = {
    get storeId(): number {
        try {
            return store?.getState()?.common?.currentUser?.value?.storeId! ||
                store?.getState()?.common?.signInResponse?.user?.storeId!;
        } catch (error) {
            return 0;
        }
    },
    storeId2: 218,

    secretKey: "uOTD2R7B8mXQeVKNffUgXFahfioXqn",

    apiUrldb: 'http://172.20.10.11:5000/',
    // apiUrldb: 'http://10.0.2.2:5000/',
    // apiUrldb: 'https://dev.capps.centizenapps.com/', //dev url
    // apiUrldb: 'https://c16zsbmj-5000.inc1.devtunnels.ms/',

    AWSImageUrl: 'https://zenbasket-dev.s3.us-west-2.amazonaws.com/',
    origin: 'https://dev.storefront.getzenbasket.com',
    blogUrl: 'https://bloggallery.s3.us-west-2.amazonaws.com/Mobile/',
    localAWSImageURL: "https://local.getzenbasket.com/aws/zenbasket-local/"
}